import React from 'react';

import { SettingHeader, SettingsContainer } from './BranchComponents';
import BranchStaticField from './BranchStaticField';
import Switch from '../../Shared/Switch';

import { withFund } from '../../../utils/formatters';

const ECommerceSettings = ({ pharmacy, organisation, onValidationError, onChange }) => {
  const { otc_enabled } = pharmacy;
  const { paid_delivery } = organisation || {};
  const { delivery_cost, delivery_fee } = paid_delivery || {};

  const handleOtcChange = (_, checked) => {
    if (checked) {
      const {
        gphc_number,
        gphc_url,
        paymentMethod,
      } = pharmacy;

      const { commissions, feature_flags } = organisation || {};
      const { otc_enabled } = feature_flags || {};
      const isMobilePayment = paymentMethod && paymentMethod.code === 4;

      if (!gphc_number) return onValidationError('GPhC Registration number incomplete');
      if (!gphc_url) return onValidationError('General Information URL incomplete');
      if (!isMobilePayment) return onValidationError("Mobile pay hasn't been activated for Pharmacy");
      if (!otc_enabled) return onValidationError("OTC hasn't been enabled for Organisation");
      if (!commissions?.defaultRate?.otc_commission) return onValidationError('Organisation E-Commerce commission rate incomplete');
    }

    onChange('otc_enabled', checked);
  };

  return (
    <SettingsContainer>
      <SettingHeader>ECommerce</SettingHeader>
      <Switch
        label="E-Commerce Enabled"
        onChange={handleOtcChange}
        checked={!!otc_enabled}
      />
      <BranchStaticField label="Delivery charge" value={withFund(delivery_cost || 0)} />
      <BranchStaticField label="Delivery service charge" value={withFund(delivery_fee || 0)} />
    </SettingsContainer>
  );
};

export default ECommerceSettings;
